import apiConfig from 'api/apiConfig'
import { isObj } from '../lib/utils'

let api = {}
// 解析config对象
apiConfig.forEach((row) => {
  if (!api[row.name]) {
    api[row.name] = (param = {}) => ({
      promise: (client) => {
        let {successBack, failBack, type, baseUrl, ...rest} = param
        if (!baseUrl) {
          baseUrl = serverUrl
        }
        if (row.apiParams && isObj(row.apiParams)) {
          Object.assign(rest, row.apiParams)
        }
        return client[row.method](baseUrl + row.url, rest, row.config, row.opts)
      }
    })
  }
})
export default api


